import { ReactNode } from 'react';

import { Cluster } from '@cast/types';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type Props = {
  noCluster?: ReactNode;
  fallback?: ((cluster: Cluster) => ReactNode) | ReactNode | false;
  children: ((cluster: Cluster) => ReactNode) | ReactNode;
};

const renderContent = (
  cluster: Cluster,
  children: ReactNode | ((cluster: Cluster) => ReactNode)
) => {
  if (typeof children === 'function') {
    return <>children(cluster)</>;
  }
  return <>{children}</>;
};

export const WhenManaged = ({
  children,
  noCluster = null,
  fallback = null,
}: Props) => {
  const { cluster, isManaged } = useCluster();
  if (!cluster) {
    return <>{noCluster}</>;
  }

  if (isManaged) {
    return renderContent(cluster, children);
  }
  return (
    <>{typeof fallback === 'function' ? fallback(cluster) : fallback || null}</>
  );
};
